import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Form, FormElement, FormElementValidators } from 'src/common/form';
import { Auth, ResetLinkModel } from 'src/common/security';
import { environment } from 'src/environments/environment';
import { TranslationManager } from 'src/common/translation';

@Component({
    selector: 'forget-password',
    templateUrl: './forget-password.component.html'
})
export class ForgetPasswordComponent implements OnInit {

    form: Form = new Form();
    siteHost: string;
    readonly environment = environment;
    error: string;
    success: boolean = false;
    translationManager = TranslationManager;

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.initForm();
        var currentRoute = this.router.url;
        var currentLocation = window.location.href;
        var diff = currentLocation.replace(currentRoute, '');
        this.siteHost = diff;
    }

    private initForm() {
        this.form.elements['username'] = new FormElement();
        this.form.elements['username'].state.mandatory = true;
        this.form.elements['username'].onValidation = FormElementValidators.stringValidator;
    }

    sendResetPassword() {

        this.error = undefined;

        if (this.form.isValid()) {

            let resetLinkModel: ResetLinkModel = new ResetLinkModel();
            resetLinkModel.redirectAddress = this.siteHost;
            resetLinkModel.userName = this.form.elements['username'].value;

            Auth.sendResetPassword(resetLinkModel).then(() => {
                this.success = true;
            }).catch((e: any) => {
                this.error = e.error.messages;
            });
        }
    }
}